import { AxiosResponse } from "axios";
import { forms, IValidationResult } from "lobbie";
import { useCallback, useEffect, useState } from "react";
import { BASE_PUBLIC_API_ROUTE, DEFAULT_ERROR_MESSAGE } from "src/constants";
import { useBrandingRedux } from "src/hooks/branding/useBrandingRedux";
import { useAxiosPublicGet } from "src/hooks/useAxios";
import { handleError, isFailedRequest, notify } from "src/utils";

export const usePublicFormTemplateGroup = (
    formTemplateGroupPublicUuid: string | undefined,
): [forms.IFormTemplateGroupLite | undefined, boolean] => {
    const getter = useAxiosPublicGet();

    const [, dispatchBranding] = useBrandingRedux();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [formTemplateGroup, setFormTemplateGroup] = useState<
        forms.IFormTemplateGroupLite | undefined
    >();

    const get = useCallback(async () => {
        if (!formTemplateGroupPublicUuid) return;

        setLoading(true);
        return getter(
            `${BASE_PUBLIC_API_ROUTE}/forms/groups?formTemplateGroupPublicUuid=${formTemplateGroupPublicUuid}`,
        )
            .then((response: AxiosResponse | void) => {
                setLoading(false);
                const result =
                    response && (response.data as IValidationResult | forms.IFormTemplateGroupLite);
                if (!result) {
                    // notify({
                    //     level: "error",
                    //     title: "Error getting forms.",
                    //     message: DEFAULT_ERROR_MESSAGE,
                    // });
                } else if (isFailedRequest(result)) {
                    notify({
                        level: "error",
                        title: "Failed to get forms.",
                        message: (result as IValidationResult).message || DEFAULT_ERROR_MESSAGE,
                    });
                } else {
                    const r = result as forms.IFormTemplateGroupLite;
                    setFormTemplateGroup(r);
                    dispatchBranding(r.location.branding);
                }
            })
            .catch((error) => {
                setLoading(false);
                handleError(error);
            });
    }, [formTemplateGroupPublicUuid, getter, dispatchBranding]);

    useEffect(() => {
        get().catch(handleError);
    }, [get]);

    return [formTemplateGroup, isLoading];
};
